import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { WindowShimService } from './window-shim.service';

@NgModule({
  imports: [CommonModule],
  providers: [WindowShimService],
})
export class WindowShimModule {}
